import React, { createContext, useState, useContext } from "react";

const conversionRates = {
  INR: 1,
  USD: 0.012,
};

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("INR");

  const convertPrice = (priceInINR) => {
    return (priceInINR * conversionRates[currency]).toFixed(2);
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, convertPrice }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
